module.exports = __webpack_public_path__ + "static/media/ils_gold_purchase_success.6b41afa6.svg";